import React, { useState, useEffect } from "react";

const ImageBox = ({imgTerm,setImgTerm}) =>{

	const[imgList, setImgList] = useState('');
	var imgs = [];

	useEffect(() => {
		const asyncFunc = async () => {
			const data = await fetch(
				`https://api.unsplash.com/search/photos?page=1&query=${imgTerm}&client_id=brmwLUeyenTyXtc6VPphHJCCtr2pjJ41gkn2sZt2ixw`
			);
		const dataJ = await data.json();
		const result = dataJ.results;
		setImgList(result.map((img) => {return <div className="col-lg-4 col-md-6" style = {{marginTop: '40px'}}><img style = {{width: '100%', height: '260px', objectFit: 'cover'}} src={img.urls.regular}></img></div>}))
		console.log(imgList)
		};
		asyncFunc();
	},[imgTerm]);

	return(
			<div className = "row">
				{imgList}
			</div>
		)
}

export default ImageBox;